/* eslint no-alert: 0 */
import React, {ReactElement, useState, useRef} from 'react';
import {
  Button,
  MenuDotsHorizontalIcon,
  IconButton
} from '@customink/pigment-react';
import {
  StorePurchaseCancelParamsType,
  useCancelPurchaseMutation
} from '../../api/storesApi';
import useOnClickOutside from '../../hooks/useOnclickOutside';

type cancelPurchaseParams = {
  storeSlug: string;
  referenceId: string;
  status: string;
};

const OrderActionDropdown: React.FC<cancelPurchaseParams> = ({
  storeSlug,
  referenceId,
  status
}: cancelPurchaseParams): ReactElement => {
  const [triggerCancelPurchaseMutation] = useCancelPurchaseMutation();
  const handleMenuRef = useRef<HTMLDivElement>(null);
  const [menuExpanded, setMenuExpanded] = useState<boolean>(false);

  const toggleMenuExpanded = () => {
    setMenuExpanded(!menuExpanded);
  };

  const onMoreClick = () => {
    if (toggleMenuExpanded !== undefined) {
      toggleMenuExpanded();
    } else {
      setMenuExpanded(!menuExpanded);
    }
  };

  useOnClickOutside(handleMenuRef, menuExpanded, toggleMenuExpanded);

  // the cancel order confirmation dialog is not available.
  const cancelPurchase = (purchase: StorePurchaseCancelParamsType) => {
    if (window.confirm('Are you sure you want to cancel?')) {
      triggerCancelPurchaseMutation(purchase);
    }
  };

  const handleCancel = () => {
    const purchaseCancelParam: StorePurchaseCancelParamsType = {
      url_slug: storeSlug,
      reference_id: referenceId
    };
    return cancelPurchase(purchaseCancelParam);
  };

  return (
    <div className="orderActionDropdown" ref={handleMenuRef}>
      <div className="orderActionMenu">
        <div className="orderActionMenuItem">
          <IconButton
            className="orderActionMenuItem-button"
            onClick={onMoreClick}
            onKeyDown={onMoreClick}>
            <span aria-label={menuExpanded ? 'Collapse' : 'Expand'}>
              <MenuDotsHorizontalIcon className="menuDot" />
            </span>
          </IconButton>
          <div
            className="orderActionMenuItem-content"
            hidden={!menuExpanded}
            aria-label="action-menu-content">
            <Button
              className="cancelOrder"
              onClick={handleCancel}
              disabled={status === 'canceled'}>
              Cancel Order
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrderActionDropdown;
